import { S3_URL } from 'constants/index';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { MyConnectionComponentPropsInterface } from 'constants/interfaces';
import useTranslate from 'hooks/useTranslate';
import React from 'react';
import { Button, Col, Image, Row, Stack } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAcceptConnectionRequestMutation, useRemoveConnectRequestMutation } from 'services';
import useAuthStore, { updateUserInfo } from 'store/auth';

const MyRequestedUsers: React.FC<MyConnectionComponentPropsInterface> = (props) => {
	const { translate } = useTranslate();
	const navigate = useNavigate();
	const { docs = [], meta = {} }: any = props.connectionData;

	const { mutateAsync: acceptRequestMutation } = useAcceptConnectionRequestMutation();
	const { mutateAsync: rejectRequestMutation } = useRemoveConnectRequestMutation();
	const userDetails: any = useAuthStore((state) => state.userInfo.user);

	const handleAcceptRequest = (id: any) => {
		updateUserInfo({ connection: userDetails?.connection + 1 });
		acceptRequestMutation(id)
			.then((_res: any) => {
				if (_res?.success) {
					props?.refetchListData('request');
				} else {
					updateUserInfo({ connection: userDetails?.connection - 1 });
				}
			})
			.catch((err: any) => {
				console.log(err);
			});
	};

	const handleRejectRequest = (id: any) => {
		rejectRequestMutation(id)
			.then((_res: any) => {
				props?.refetchListData('request');
			})
			.catch((err: any) => {
				console.log(err);
			});
	};
	return (
		<div>
			{meta?.totalDocs > 0 && (
				<h6 className="mb-3">
					{translate('Common.connectionsRequest')}{' '}
					<span className="fw-bold">{`(${meta?.totalDocs})`}</span>
				</h6>
			)}
			<Row className="connections-row">
				{docs.length > 0 ? (
					docs?.map((res: any) => (
						<Col key={`requested-${res?.name}-${res?.userId}}`} xxl={4} md={6}>
							<Stack className="connections-box gap-3">
								<div className="d-flex gap-3 h-100">
									<div
										className="connections-box-profile position-relative rounded-circle"
										onClick={() => {
											navigate(`/seeker/profile/${res?.userId}`);
										}}
									>
										<Image
											src={`${S3_URL}${res?.profilePicture}`}
											onError={({ currentTarget }) => {
												currentTarget.onerror = null;
												currentTarget.src = IMAGE_PATHS.UserDefault;
											}}
											alt="logo"
											className="rounded-circle w-100 h-100 object-fit-cover"
											loading="lazy"
										/>
									</div>
									<Stack className="gap-2 flex-1">
										<Link style={{ textDecoration: 'none' }} to={`/seeker/profile/${res?.userId}`}>
											<h6 className="fw-bold mb-0">{res?.name}</h6>
										</Link>
										<p className="mb-0">{res?.description}</p>
										<div className="d-flex gap-2 mt-auto">
											<Button
												onClick={() => handleAcceptRequest(res?.userId)}
												className="filled-btn rounded-pill lh-1"
											>
												{translate('Button.accept')}
											</Button>
											<Button
												onClick={() => handleRejectRequest(res?.userId)}
												className="gray-transparent-btn rounded-pill lh-1"
											>
												{translate('Button.reject')}
											</Button>
										</div>
									</Stack>
								</div>
							</Stack>
						</Col>
					))
				) : (
					<Col>
						<Stack className="posted-job-box">
							<p className="mb-0">{translate('Common.noRequest')}</p>{' '}
						</Stack>
					</Col>
				)}
			</Row>
		</div>
	);
};

export default MyRequestedUsers;
